import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const client = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const userService = {
  async list() {
    const res = await client.get('/users');   // FIXED
    return res.data;
  },
  async create(payload) {
    const res = await client.post('/users', payload);   // FIXED
    return res.data;
  },
  async update(id, payload) {
    const res = await client.put(`/users/${id}`, payload);   // FIXED
    return res.data;
  },
  async remove(id) {
    const res = await client.delete(`/users/${id}`);   // FIXED
    return res.data;
  },
};

export default userService;
